import {useEffect} from 'react';
import {Link, useParams} from 'react-router-dom';
import {useCustomPage} from '@common/custom-page/use-custom-page';
import {CustomPageBody} from '@common/custom-page/custom-page-body';
import {PageMetaTags} from '@common/http/page-meta-tags';
import {PageStatus} from '@common/http/page-status';
import {CommerceLayout} from '@app/checkout/website-checkout-page';
import './rekaweb-info-page.css';

export function RekawebInfoPage() {
  const {pageSlug, pageId} = useParams();
  const query = useCustomPage(pageId || pageSlug);
  useEffect(() => {window.scrollTo(0, 0);}, [pageSlug, pageId]);
  return <CommerceLayout>
    <PageMetaTags query={query} />
    <main className="rekaweb-info-page">
      <nav className="rekaweb-info-nav" aria-label="Maklumat Rekaweb">
        {[['about-us', 'Tentang Kami'], ['privacy-policy', 'Privasi'], ['terms-of-service', 'Terma Perkhidmatan']].map(([slug, label]) => <Link key={slug} to={`/pages/${slug}`} aria-current={query.data?.page.slug === slug ? 'page' : undefined}>{label}</Link>)}
      </nav>
      <article className="rekaweb-info-card">{query.data ? <CustomPageBody page={query.data.page} /> : <PageStatus query={query} loaderClassName="my-40" />}</article>
    </main>
  </CommerceLayout>;
}
